import { Component, ElementRef, EventEmitter, Output, ViewChild } from "@angular/core";
import { TradableWallet } from "@models/interfaces/tradable_wallet";

@Component({
	selector: "carousel-slider",
	templateUrl: "./carousel-slider.component.html",
	styleUrls: ["./carousel-slider.component.scss"],
	standalone: false
})
export class CarouselSliderComponent {
	@ViewChild("carouselContainer") carouselContainer: ElementRef;

	@Output() public onTradableClick = new EventEmitter<TradableWallet>();
	public index: number = 0;
	public hideNextButton: boolean = false;

	public onPreviousClick(): void {
		this.index--;
		this.carouselContainer.nativeElement.scrollLeft = this.carouselContainer.nativeElement.clientWidth * this.index;
		this.hideNextButton = false;
	}

	public onNextClick(): void {
		this.index++;
		this.carouselContainer.nativeElement.scrollLeft = this.carouselContainer.nativeElement.clientWidth * this.index;

		if (
			this.carouselContainer.nativeElement.clientWidth - this.carouselContainer.nativeElement.scrollLeft <
			this.carouselContainer.nativeElement.clientWidth
		) {
			this.hideNextButton = true;
		}
	}
}
